import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import HistoricoContratacaoStore from "../stores/HistoricoContratacaoStore";
import { HistoricoContratacaoFiltro } from "../components/HistoricoContratacaoFiltro";
import { formatarDataISO8601} from "../../../utils/formatar";
import { LoadingBlockFields } from "../../comum/components/LoadingBlockFields";
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { formatarCPF, formatCheckQuarentena } from "../../../utils/functions";
import { MensagemErro } from "../../comum/components/MensagemErro";
import {Button} from "reactstrap";
import FontAwesome from 'react-fontawesome';

@inject("store")
@DataWrapper
@observer
export class HistoricoContratacao extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.modalStore = this.props.store.modalStore;
        this.loginStore = this.props.store.loginStore;
        this.controller = new HistoricoContratacaoStore();
        this.simulaQuarentena = this.controller.simulaQuarentena;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Histórico de contratos e simulação de quarentena");
        this.controller.carregarTabela();
    }

    render() {

        const COLUNASMOT = [
            { key: "1", label: "CPF", dataField: "cpf", width: "150", isKey: true, dataFormat: formatarCPF },
            { key: "2", label: "Nome", dataField: "nome", width: "200" },
            { key: "3", label: "e-mail", dataField: "email", width: "200" },
            { key: "4", label: "Data Nascimento", dataField: "dataNascimento", width: "200", dataFormat: formatarDataISO8601 }]
        
        const COLUNASCONTRATO = [
            { field: "matricula", label: "Matricula/ID MOT",  style:{width: "100"}},
            { field: "sistemaOrigem", label: "Contrato",  style:{width: "100"}},
            { field: "dataInicio", label: "Inicio",  style:{width: "100"}},
            { field: "dataTermino", label: "Término",  style:{width: "100"}},
            { field: "cargo", label: "Cargo",  style:{width: "100"}},
            { field: "gestor", label: "Gestor",  style:{width: "100"}}]
        
         const COLUNASVALIDACAO =[
            { key: "1", label: "ID", dataField: "id", width: "5", isKey: true},
            { key: "2", label: "Tipo", dataField: "tipoValidacao", width: "10", dataFormat: formatCheckQuarentena  },
            { key: "3", label: "Mensagem", dataField: "mensagemValidacao", width: "100" } ]        

        /* Especificar botões nos itens da tabela (Se houverem) */
        let acoesItens = ["visualizarHistoricoContratos"];
        const options_table = {
            noDataText: "Não há registro.",
        };

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.appStore.width > 768}
                        <LoadingBlockFields carregando={this.controller.carregando}>
                            <HistoricoContratacaoFiltro
                                onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                controller={this.controller}
                                history={this.props.history}
                                location={this.props.location}
                                simular={this.controller.simulaQuarentena}
                            />
                            <div className="separador"></div>
                            {this.controller.dadosMot && <h4>Dados da pessoa</h4>}
                            {this.controller.dadosMot &&
                                <BootstrapTable ref='table' version='4' options={options_table} data={this.controller.dadosMot} striped hover condensed TableHeaderColumn>
                                    {
                                        COLUNASMOT.map(column =>
                                            <TableHeaderColumn columnTitle {...column} >
                                                {column.label}
                                            </TableHeaderColumn>
                                        )
                                    }
                                </BootstrapTable>}
                            <div className="separador"></div>
                            {this.controller.dadosContrato && <h4>Contratos da pessoa</h4>}
                            {this.controller.dadosContrato && 
                            <TabelaFluxo
                                keyField={"matricula"}
                                habilitarSelecaoMultipla={false}
                                listaItens={this.controller.dadosContrato}
                                parametroVisualizar={"matricula"}
                                colunas={COLUNASCONTRATO}
                                temBusca={false}
                                acoesItens={acoesItens}
                                loading={false}
                                colunaOrdenacaoPadrao={"matricula"}
                                nomeFluxo={'HistoricoContratos'}
                                onCardClick={this.props.onCardClick}
                                tipoOrdenacaoPadrao={'asc'}
                            />
                            }
                            <div className="separador"></div>
                            {this.controller.dadosValidacao && this.controller.dadosValidacao.length > 0 && <h4>Validação de Quarentena</h4>}
                            {this.controller.dadosValidacao && this.controller.dadosValidacao.length > 0 &&
                                <BootstrapTable ref='table' version='4' data={this.controller.dadosValidacao} striped hover condensed TableHeaderColumn tableBodyClass="table-custom-mot">
                                    {
                                        COLUNASVALIDACAO.map(column =>
                                            <TableHeaderColumn columnTitle {...column} >
                                                {column.label}
                                            </TableHeaderColumn>
                                        )
                                    }
                                </BootstrapTable>}
                            {this.controller.erro &&
                                <MensagemErro>
                                    {this.controller.erro}
                                </MensagemErro>
                            }
                        </LoadingBlockFields>
                    </div>
                </div>
            </div>
        );
    }
}